"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const gameLevelsRouter = {
  path: '/game-levels',
  component: _index.default,
  redirect: 'gameLevels',
  name: 'GameLevels',
  meta: {
    title: 'gameLevels.title',
    icon: 'faq'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/game-levels/list.vue'))),
    name: 'GameLevels',
    meta: {
      title: 'gameLevels.title',
      noCache: true,
      icon: 'faq'
    }
  }, {
    path: 'edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/game-levels/manage.vue'))),
    name: 'Edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'gameLevels.edit',
      noCache: true,
      activeMenu: '/game-levels/list',
      hidden: true
    }
  }, {
    path: 'add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/game-levels/manage.vue'))),
    name: 'Add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'gameLevels.add',
      noCache: true,
      activeMenu: '/game-levels/list',
      hidden: true
    }
  }]
};
var _default = exports.default = gameLevelsRouter;